<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-alert v-if="disableAutomaticPaymentAlert" show="" variant="success">Pago automatico desactivado</b-alert>
      </b-col>
    </b-row>
        <h1>Realizar Pago</h1>
        <b-row>
          <!-- <b-col md="3">
            <b-form-group
              label="Responsable del Pago"
              label-for="input-name"
            >
              <b-form-input
                id="input-name"
                v-model="name"
                placeholder="Nombre y apellido"
              ></b-form-input>
            </b-form-group>
          </b-col> -->
          <b-col md="3">
            <!--
             <b-form-group
              label="Correo Electrónico"
              label-for="input-email"
            >
              <b-form-input
                id="input-email"
                v-model="email"
                placeholder="correo electrónico"
              ></b-form-input>
            </b-form-group>-->
          </b-col>
          <b-modal ref="modal-payment" hide-footer title="¿Estás seguro(a) que deseas realizar el pago?">
            <!-- <div class="form-check">
              <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked>
              <label class="form-check-label" for="exampleRadios1">
                OXXO
              </label>
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/66/Oxxo_Logo.svg" width="10%">
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2">
              <label class="form-check-label" for="exampleRadios2">
                Pago con tarjeta
              </label>
              <img src="https://aestheticsolutions.mx/wp-content/uploads/2020/02/pagos-con-tarjeta.png" width="10%">
            </div> -->
            <b-form-group label="Selecciona método de pago" v-slot="{ ariaDescribedby }">
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" value="CARD">Pago con Tarjeta</b-form-radio>
              <b-form-radio v-model="selectedPaymentMethod" :aria-describedby="ariaDescribedby" name="some-radios" value="OXXO">Pago en OXXO</b-form-radio>
            </b-form-group>
             <br>
             <div>
                <b-button
                  variant="success"
                  block
                  @click="payConcessions"
                  :disabled="!(selected.length > 0) || pagando"
                >
                  <b-spinner v-if="pagando" small type="grow"></b-spinner>
                  Pagar
                </b-button>
             </div>
          </b-modal>
        </b-row>
        <b-row>
        <b-col md="12" class="my-1">
          <b-form-group
            label="Seleccionar Concesiones a Pagar"
            label-for="input-conession"
          >
            <b-input-group>
              <b-form-input v-model="filter" class="form-control"  id="input-conession" placeholder="Buscar concesión"></b-form-input>
              <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
              </b-input-group-append>
              <b-col class="text-right" sm="2" md="2">
                <p id="cuantity">Cantidad a Pagar: <b> ${{ total() }}</b></p>
              </b-col>
              <b-col sm="2" md="2">
                <b-button
                  variant="success"
                  block
                  @click="showModal"
                  :disabled="!(selected.length > 0) || pagando"
                  >
                  <b-spinner v-if="pagando" small type="grow"></b-spinner>
                  Pagar
                </b-button>
              </b-col>
              <b-col md="2"></b-col>
              <!-- <b-col md="2">
                <b-button :disabled="paymentButton" @click="showAutomaticPaymentModal" variant="outline-primary" >Habilitar pago automático</b-button>
              </b-col> -->
              <b-col  md="2" v-if="cardId">
                <b-button variant="outline-danger" @click="disableAutomaticPayment" >Cancelar pago automático</b-button>
              </b-col>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <h6 id="etiqueta">En caso de ya haber realizado tu pago mensual en breve se verá reflejado, tu servicio <strong>NO será interrumpido</strong></h6>
      <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-checkbox-group
        id="checkbox-group-2"
        v-model="selected"
        @change="selectedObjectUpdate"
        :aria-describedby="ariaDescribedby"
        name="flavour-2"
      >
    <b-overlay :show="pagando" rounded="sm">
      <b-table
        show-empty
        stacked="md"
        :items="getOrderPayment"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        empty-text="No existen registros por mostrar"
        emptyFilteredText="No existen registros por mostrar"
      >
        <template v-slot:cell(amount)="row">
          {{ '$' + row.item.amount + ' MXN' }}
        </template>
        <template v-slot:cell(tempVerification)="row">
           <template v-if="row.item.tempVerification == undefined">
          </template>
          <template v-else>
             <div :class="statusDictionary[row.item.tempVerification].class">{{ statusDictionary[row.item.tempVerification].label }}</div>
          </template>
        </template>
        <template v-slot:cell(acciones)="row">
          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
            {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} Detalles
          </b-button>
        </template>
        <template v-slot:cell(id)="row">
          <b-form-checkbox :value="row.item.numConcesion"></b-form-checkbox>
        </template>

        <template v-slot:cell(vehicleBrand)="row">
          <div v-if="row.item.vehicle">
            {{ row.item.vehicle.brand + ' ' + row.item.vehicle.model }}
          </div>
        </template>
        <template v-slot:cell(licensePlate)="row">
          <div v-if="row.item.vehicle">
            {{ row.item.vehicle.licensePlate }}
          </div>
        </template>

        <template #row-details="row">
          <b-table
            :items="row.item.periodos"
            small
            borderless
            :fields="['periodos']"
            >
            <template v-slot:cell(periodos)="row">
              {{ replaceMonth(row.item) }}
            </template>
          </b-table>
        </template>
      </b-table>
      </b-overlay>
     </b-form-checkbox-group>
    </b-form-group>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          align="right"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div v-if="getOrderPayment.length">
      <div class="text-center" v-if="$apollo.queries.getOrderPayment.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
      </div>
    </div>
    </div>
</template>

<script>
// import { encrypt } from '@/config/headers'
import gql from 'graphql-tag'
// import axios from 'axios'
import * as secrets from '@/services/secrets'
import { mapState } from 'vuex'
import headers from '@/config/headers.js'
import crypto from 'crypto-js'
import config from '../../../environmentConfig.json'
const GET_USER_CONCEIONARIO_BY_CONCESIONAROID = gql`
  query getUserConcesionario($concesionarioId: Int) {
    getUserConcesionario(concesionarioId: $concesionarioId){
      id
      email
      mpId
      mpActive
    }
  }
`
const GET_AUTH_PAYMENTS = gql`
  query getAuthPayments ($rfc: String){
      getAuthPayments (rfc: $rfc){
      pendingPayments
    }  
  }
`

const GENERATE_OXXO_PAYMENT = gql`
  mutation generateOxxoPaymentSub($paymentOxxoSubInput: paymentOxxoSubInput) {
    generateOxxoPaymentSub(paymentOxxoSubInput: $paymentOxxoSubInput) {
      pk,
      sk,
      paymentURL
    }
  }
`

const ACTIVATE_AUTOMATIC_PAYMENTS = gql`
mutation activateAutomaticPayment($concesionarioId: Int, $cardId: String){
  activateAutomaticPayment(concesionarioId: $concesionarioId, cardId: $cardId) {
    id
  }
}
`
const DISABLE_AUTOMATIC_PAYMENT = gql`
mutation disableAutomaticPayment($concesionarioId: Int){
  disableAutomaticPayment(concesionarioId: $concesionarioId){
    id
    name
    email
  }
}
`
const GET_CONCECIONARIO_BY_ID = gql`
  query getConcesionarioId($id: Int) {
    getConcesionarioId(id: $id){
      id
      name
      automaticPayment
      cardId
      phoneNumber
      address {
        state
        city
        postalCode
        street
        suburb
        extNumber
        intNumber
      }
    }
  }
`
export default {
  data() {
    return {
      concesionario: {},
      fields: [
        { key: 'id', label: 'Selección' },
        { key: 'pk', label: 'RFC' },
        { key: 'numConcesion', label: 'Número de Concesión', sortable: true, sortDirection: 'desc' },
        { key: 'vehicleBrand', label: 'Vehiculo' },
        { key: 'licensePlate', label: 'Placa' },
        // { key: 'periodos', label: 'Periodos' },
        { key: 'amount', label: 'Monto' },
        { key: 'tempVerification', label: 'Estado del pago' },
        'acciones',
        //  { key: 'vehicle.brand', label: 'Marca Vehículo' },
        //  { key: 'vehicle.serialNumber', label: 'Número de Serie' },
      ],
      autoRefresh: true,
      statusDictionary: {
        PAYMENT_IN_VERIFICATION: { label: 'Pago en verificación', class: 'text-warning font-weight-bold' },
        PAYMENT_VERIFICATION_COMPLETED: { label: 'Verificación completada', class: 'text-success font-weight-bold' },
      },
      totalRows: 1,
      currentPage: 1,
      pagando: false,
      userMp: {},
      disableAutomaticPaymentAlert: false,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idConcesionAction: null,
      dataLoad: -1,
      selected: [],
      allowedToPay: null,
      selectedPaymentMethod: 'CARD',
      name: '',
      email: '',
      payModal: false,
      automaticPaymentModal: false,
      getUserMp: {},
      successPay: '',
      confirmPay: false,
      cardId: null,
      rfc: '',
      selectedObject: [],
      getOrderPayment: [],
      paymentButton: true,
      months: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      },
    }
  },
  apollo: {
    getOrderPayment: {
      query: gql`query getOrderPayment ($rfc: String) {
          getOrderPayment (rfc: $rfc) {
            numConcesion
            amount
            periodos
            tempVerification
            vehicle {
              licensePlate
              brand
              model
            }
            pk
            sk
          }
        }`,
      context: headers(),
      variables () {
        return {
          rfc: this.$store.state.user.rfc,
        }
      },
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        // console.log(this.dataLoad)
        // console.log(data)
        if (data.getOrderPayment) {
          this.totalRows = data.getOrderPayment.length
        }
      },
    },
    getConcesionarioId: {
      query: GET_CONCECIONARIO_BY_ID,
      context: headers(),
      variables() {
        return {
          id: parseInt(this.$store.state.user.franchisee),
        }
      },
      result({ data }) {
        // console.log(data)
        this.cardId = data.getConcesionarioId.automaticPayment
      },
      error(error) {
        console.log(error)
      },
    },
  },
  created: function () {
    // console.log('Baseurl')
    // console.log(config[process.env.NODE_ENV].baseURL)
    // `this` hace referencia a la instancia vm
    this.dataLoad = parseInt(this.getFranchisee)
    // console.log(this.getFranchisee)
  },
  mounted() {
    this.checkPaymentAllowed()
    this.$apollo.query({
      query: GET_USER_CONCEIONARIO_BY_CONCESIONAROID,
      context: headers(),
      variables: {
        concesionarioId: parseInt(this.$store.state.user.franchisee),
      },
    })
      .then(({ data }) => {
        // console.log(data)
      })
      .catch(e => {
        console.log(e)
      })
    this.$apollo.query({
      query: GET_CONCECIONARIO_BY_ID,
      context: headers(),
      variables: {
        id: parseInt(this.$store.state.user.franchisee),
      },
    })
      .then(({ data }) => {
        this.concesionario = data.getConcesionarioId
      })
      .catch(e => {
        console.log(e)
      })
  },
  methods: {
    checkPaymentAllowed() {
      this.$apollo.query({
        query: GET_AUTH_PAYMENTS,
        context: headers(),
        variables: {
          rfc: this.$store.state.user.rfc,
        },
      }).then(({ data }) => {
        this.allowedToPay = !data.getAuthPayments.pendingPayments
      })
    },
    disableAutomaticPayment() {
      this.$apollo.mutate({
        mutation: DISABLE_AUTOMATIC_PAYMENT,
        context: headers(),
        variables: {
          concesionarioId: parseInt(this.$store.state.user.franchisee),
        },
      })
        .then(result => {
          console.log(result)
          this.disableAutomaticPaymentAlert = true
          this.$apollo.queries.getConcesionarioId.refetch()
          setTimeout(() => {
            this.disableAutomaticPaymentAlert = false
          }, 2000)
        })
        .catch(error => {
          console.log(error)
        })
    },
    registerAutomaticPayment(cardId) {
      this.$apollo.mutate({
        mutation: ACTIVATE_AUTOMATIC_PAYMENTS,
        context: headers(),
        variables: {
          concesionarioId: parseInt(this.$store.state.user.franchisee),
          cardId: cardId,
        },
      })
        .then(data => {
          this.automaticPaymentModal = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAutomaticPaymentModal() {
      this.automaticPaymentModal = true
    },
    total() {
      // console.log(this.selectedObject)
      return this.selectedObject.map(el => el.amount).reduce((a, b) => a + b, 0)
    },
    selectedObjectUpdate() {
      this.selectedObject = []
      // console.log(this.getOrderPayment)
      setTimeout(() => {
        this.getOrderPayment.forEach(order => {
          if (this.selected.includes(order.numConcesion)) {
            // console.log(this.selected)
            this.selectedObject.push(order)
          }
        })
      }, 50)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    replaceMonth(date) {
      const month = this.months[date.split('-')[1]]
      const newDate = date.split('-')[0] + '-' + month
      return newDate
    },
    generatedURL() {
      // console.log(this.selected)
      const periodo = (new Date().getFullYear()) + '-' + (new Date().getMonth() + 1)
      let baseURL = config[process.env.NODE_ENV].baseURL
      baseURL = baseURL + `rfc=${this.$store.state.user.rfc}`
      const concesionesList = this.selected

      baseURL = baseURL + '&concesiones=' + concesionesList
      baseURL = baseURL + '&periodo=' + periodo
      baseURL = baseURL + '&amount=' + this.total()
      baseURL = baseURL + '&email=' + this.$store.state.user.email
      baseURL = baseURL + '&paidBy=' + this.name
      baseURL = baseURL + '&mpId=' + this.userMp.id
      return baseURL
    },
    handlePayment(e) {
      console.log(e)
    },
    payConcessions() {
      this.pagando = true
      this.$apollo.query({
        query: GET_AUTH_PAYMENTS,
        context: headers(),
        variables: {
          rfc: this.$store.state.user.rfc,
        },
      }).then(({ data }) => {
        this.allowedToPay = !data.getAuthPayments.pendingPayments
        if (this.allowedToPay) {
          const paymentResume = {
            concesionario: {
              rfc: this.selectedObject[0].pk,
              name: this.$store.state.user.name,
              email: this.$store.state.user.email,
              phoneNumber: this.concesionario.phoneNumber,
            },
            totalAmount: this.total(),
            concesiones: this.selectedObject.map(c => {
              return {
                concesionNumber: c.numConcesion,
                periodos: c.periodos,
                amount: c.amount,
              }
            }),
            timestamp: new Date().toISOString(),
            address: this.concesionario.address,
          }
          if (this.selectedPaymentMethod === 'CARD') {
            secrets.retrieveSecretCybersource().then(s => {
              const secretKey = JSON.parse(s).secret_key
              const paymentString = JSON.stringify(paymentResume)
              const encryptedPaymentDetails = crypto.AES.encrypt(paymentString, secretKey).toString()
              const urlService = `${config[process.env.NODE_ENV].securePayment}paymentConfirmation?payment=${encryptedPaymentDetails}`
              // const urlService = `http://localhost:4000/paymentConfirmation?payment=${encryptedPaymentDetails}`
              // console.log(urlService)
              window.location = urlService
            }).catch(e => console.log(e))
          } else {
            delete this.concesionario.address.__typename
            console.log(paymentResume)
            this.$apollo.mutate({
              mutation: GENERATE_OXXO_PAYMENT,
              context: headers(),
              variables: {
                paymentOxxoSubInput: paymentResume,
              },
            }).then(data => {
              console.log(data)
              window.open(data.data.generateOxxoPaymentSub.paymentURL, '_blank')
            }).catch(e => {
              console.log(e)
            })
          }
        } else {
          this.pagando = false
          alert('Tienes pagos pendientes por favor espera a que concluyan')
        }
      })
    },
    closeModal() {
      this.$refs['modal-payment'].hide()
    },
    showModal(user) {
      this.$refs['modal-payment'].show()
    },
  },
  computed: {
    ...mapState(['user']),
    getFranchisee() {
      return this.$store.state.user.franchisee
    },
  },
}
</script>
<style>
#total {
    margin-left: 5px;
    color: black;
    font-weight: 700;
}
#id {
  color: black;
  margin-left: 5px;
}
#successPayText {
  color: black;
  font-size: x-large;
   font-weight: 600;
}
.text-footer {
  font-size: 9px;
  color: #999;
}
.logo {
  width: 5.25em;
  height: 1.25em;
  background: url('https://http2.mlstatic.com/resources/frontend/statics/fury_px-checkout-frontend/e9700bddbbe3d0e284fbc07c266041cd.png') no-repeat;
}
#etiqueta {
  text-align: center;
  color: #fff;
  background-color: rgb(201, 64, 10);
}
</style>
